import { render, staticRenderFns } from "./Carousel4Wrapper.vue?vue&type=template&id=f04297ca&"
import script from "./Carousel4Wrapper.vue?vue&type=script&lang=js&"
export * from "./Carousel4Wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports